import { Flex } from '@amzn/storm-ui';
import styled from 'styled-components';

export const PageContainer = styled(Flex)`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.color.gray[0]};
  padding-top: 5rem;
  align-items: center;
`;

export const ContentWrapper = styled(Flex)`
  max-width: 37.5rem;
  width: 100%;
  align-items: center;
  gap: ${(props) => props.theme.spacing.l};
`;
